var data = require("./font-fix-data");

var encoding = "Unicode",
    dataMap = {};

data.forEach(function(fontData) {
    dataMap[fontData.font] = dataMap[fontData.font] || {};
    dataMap[fontData.font][fontData.style] = fontData;
});

function fixFont(doc, name, style) {
    var fontData;
    try {
        fontData = dataMap[name][style];
    } catch (e) {
        return;
    }
    if (!fontData) return;

    var font = doc.internal.getFont(name, style);

    for (var code in fontData.widths) {
        if (Object.prototype.hasOwnProperty.call(fontData.widths, code))
            font.metadata[encoding].widths[code] = fontData.widths[code];
    }
    font.metadata[encoding].widths[160] = fontData.widths[32];
}

function fixAllFonts(doc) {
    var fontList = doc.getFontList(),
        styles;

    function eachFontName(fontName) {
        styles = fontList[fontName];
        styles.forEach(function(style) {
            fixFont(doc, fontName, style);
        });
    }

    for (var fontName in fontList) {
        if (Object.prototype.hasOwnProperty.call(fontList, fontName) && dataMap[fontName]) {
            eachFontName(fontName);
        }
    }
}

// jsPDF.API.events.push([
// 	'addFont',
// 	function(font) {
//         var newFontData = data[font.PostScriptName];
//         if (newFontData) {
//             for (var code in newFontData) {
//                 if (newFontData.hasOwnProperty(code)) font.metadata[encoding].widths[code] = newFontData[code];
//             }
//         }
// 	}
// ]);

module.exports = fixAllFonts;
